var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-order"},[_c('d-navbar-nav',{staticClass:"flex-row"},[_c('notification-nav')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }